import { POIApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const poi = new POIApi(config);

export default poi;
